import { defineCopy } from "@tami/core/intl";

import { REUSABLE_MODAL_COPY_EN_US } from "./en-us/reusable-modal.copy";
import { REUSABLE_MODAL_COPY_ES_ES } from "./es-es/reusable-modal.copy";

/** Textos do modal reutilizável. */
export const REUSABLE_MODAL_COPY_PT_BR = {
  close: "Fechar",
  back: "Voltar",
} as const;

export const REUSABLE_MODAL_COPY = defineCopy(REUSABLE_MODAL_COPY_PT_BR, {
  "en-US": REUSABLE_MODAL_COPY_EN_US,
  "es-ES": REUSABLE_MODAL_COPY_ES_ES,
});
